import React, { useEffect, useState } from "react";
// import Tabs from './tabs';
import "./css.css";
import img1 from "../img/ETSY_1D.png";
import img2 from "../img/ETSY_1M.png";
import img3 from "../img/ETSY_1Y.png";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";

import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function
 **/

export const Page1 = (props) => {
  const [pic, setPic] = useState(img1);
  const [estimation, setConfidence] = useState(true);
  const history = useNavigate();
  const [url, setUrl] = useState(window.location.href);
  const [userId, setUserId] = useState("");
  const [key, setKey] = useState('page1_1D');
  const [selectedValue, setSelectedValue] = useState(50);
  const [isRangeMoved, setIsRangeMoved] = useState(false);

  const handleRangeChange = (event) => {
    setSelectedValue(event.target.value);
  };

  async function addclick(data) {
    console.log(data);
    const docRef = await addDoc(collection(db, "clicksdata"), {data,});
  }

  const submit = async () => {
    console.log(selectedValue);
    localStorage.setItem("page1_confidence",selectedValue);
    const page1_confidence_button = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: "page1_confidence_button",
    };
    history(`/page1A/?,${userId}`);
    addclick(page1_confidence_button);
  }

  const button = async (eventKey) => { 
    setKey(eventKey)
    const clickdata = {
      time: Date.now(),
      userId: localStorage.getItem("user_id"),
      buttonType: eventKey
    };
    addclick(clickdata);
    if (eventKey === "page1_1D") {
      setPic(img1);
    }
    if (eventKey === "page1_1M") {
      setPic(img2);
    }
    if (eventKey === "page1_1Y") {
      setPic(img3);
    }
  }  

  useEffect(() => {
    const iosa = url.split(",");
    setUserId(iosa[1]);
  }, []);

  return (
    <div className="main">
      <div className="header">
        <h1>CORPORATION T</h1>
        <h3>Current Price: 168.32 USD</h3>
      </div>
      <div className="grid">
        <div className="webtabs">
          <Tabs
            defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3" activeKey={key}
            onSelect={(e) => button(e)}
          >
            <Tab eventKey="page1_1D" title="1D">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page1_1M" title="1M">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page1_1Y" title="1Y">
              <img className="img" src={pic} alt="" />
            </Tab>
            <Tab eventKey="page1_details" title="Details">
              {/* <img className="img1" src={pic} alt="" /> */}
              <table class="table table-hover table-dark table-striped">
                <tbody>
                  <tr>
                    <th scope="row"></th>
                    <td>Open</td>
                    <td>164.56</td>
                    <td>Beta</td>
                    <td>2.93</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>High</td>
                    <td>169.5</td>
                    <td>Avg Volume</td>
                    <td>3510280</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Low</td>
                    <td>163.88</td>
                    <td>Market Cap</td>
                    <td>613254105.72</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Close</td>
                    <td>168.32</td>
                    <td>52 Week High</td>
                    <td>251.86</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Adj Close</td>
                    <td>168.32</td>
                    <td>52 Week Low</td>
                    <td>69.35</td>
                  </tr>
                  <tr>
                    <th scope="row"></th>
                    <td>Volume</td>
                    <td>2763700</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="page1_profile" title="Profile">
              {/* <img className="img" src={pic} alt="" /> */}
              <p className="profileinfo"> Sector: Consumer Cyclical<br></br><br></br>
                This corporation, along with its affiliated entities, operates digital marketplaces connecting <br></br>
                buyers and sellers in multiple countries. <br></br>
                Its main platform allows artists and entrepreneurs to sell their products to various consumers. <br></br> 
                The corporation also operates a platform dedicated to the trade of musical instruments, a fashion reselling platform, <br></br>
                and a marketplace specializing in unique handmade items.
                Furthermore, it provides seller services,<br></br>
                such as payment processing, advertising, and discounted shipping label purchases in select countries. <br></br>
                Additionally, it offers a suite of tools for sellers, including a dashboard for inventory management, order tracking, <br></br> 
                and communication with repeat customers, as well as access to educational resources, online forums, and a community-building program for sellers. 
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="info">

        {estimation ? (
            <div class="text-center">
              <div>
                <h1>YOUR INITIAL PREDICTION</h1>
                <p>Based on the information available, what is your prediction of the stock's price, in $, exactly one month later?
                </p>
              </div>
              <Formik
                initialValues={{ page1_prediction: "" }}
                onSubmit={(values) => {
                  console.log(values.page1_prediction);
                  localStorage.setItem("page1_prediction", values.page1_prediction);
                  const page1_prediction_button = {
                    time: Date.now(),
                    userId: localStorage.getItem("user_id"),
                    buttonType: "page1_prediction_button"
                  };
                  addclick(page1_prediction_button);
                  setConfidence(false);
                }}
                validationSchema={Yup.object({
                  page1_prediction: Yup.number().max(10000).min(0).required("prediction is required")
                })}
              >
                {(formik, isSubmitting) => (
                  <Form>
                    <div className="d-flex justify-content-center">
                      <div className="col-sm-4">
                        <Field name="page1_prediction" className={ formik.touched.page1_prediction && formik.errors.page1_prediction ? "form-control is-invalid" : "form-control" } type="text" placeholder="numbers only"/>
                      </div>
                    </div>
                    <br></br>
                    <div class="text-center">
                      <Button variant="dark" className="estbutton" type="submit">Submit</Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div class="text-center">
              <div>
                <h1>YOUR CONFIDENCE LEVEL</h1>
                <p> Please move the marker to indicate how confident you are that your prediction is accurate, from 0 to 100. 
                  <span className="marker_span"><br></br>0- I am definitely wrong.
                  100- I am definitely right. </span><br></br>
                </p>
              </div>
              <Form1.Range name="page1_confidence" value={selectedValue} onChange={handleRangeChange} onInput={() => setIsRangeMoved(true)}/>
              <p>Confidence level: {isRangeMoved ? selectedValue : "none"}</p>
              <Button variant="dark" className="estbutton" type="submit" onClick={submit} disabled={!isRangeMoved}>Submit</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
